import { Fragment } from 'react';

import Acts from 'components/Admin/InvoiceDetail/Acts';
import Charges from 'components/Admin/InvoiceDetail/Charges';
import Invoice from 'components/Admin/InvoiceDetail/Invoice';
import Payments from 'components/Admin/InvoiceDetail/Payments';
import Settings from 'components/Admin/InvoiceDetail/Settings';

const InvoiceDetail = () => (
    <Fragment>
        <Invoice />
        <Settings />
        <Payments />
        <Charges />
        <Acts />
    </Fragment>
);

export default InvoiceDetail;
